define(function(require){
    'use strict';

    var Marionette  = require('marionette');
    var Template    = require('text!popovers/staff_select/template/body.tpl').default;

    return Marionette.ItemView.extend({
        // Template
        template : Template,

        /*
        *   function serializeData()
        *   Generate template data
        *   @return {object} templateData
        */
        serializeData: function(){
            return {
                staff: this.collection.toJSON()
            };
        }
    });
});
